import { DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDateRangeMoveWeightDetail extends Layout {
    labelAdded: Label;
    labelBrTrackScoreDetail1: Label;
    labelBrTrackScoreDetail3: Label;
    labelBrTrackScoreDetail4: Label;
    labelDividendBrTrack: Label;
    labelDividendOffAcptd: Label;
    labelDividendPaprwork: Label;
    labelDividendRateConf: Label;
    labelDivisorBrTrack: Label;
    labelDivisorOffAcptd: Label;
    labelDivisorPaprwork: Label;
    labelDivisorRateConf: Label;
    labelLeftParenBrTrack: Label;
    labelLeftParenOffAcptd: Label;
    labelLeftParenPaprwork: Label;
    labelLeftParenRateConf: Label;
    labelOffAcptdScoreDetails3: Label;
    labelOffAcptdScoreDetails4: Label;
    labelOffAcptdScoreDetails: Label;
    labelPaprworkScoreDetails3: Label;
    labelPaprworkScoreDetails4: Label;
    labelPaprworkScoreDetails: Label;
    labelRateConfScoreDetail1: Label;
    labelRateConfScoreDetail3: Label;
    labelRateConfScoreDetail4: Label;
    labelRightParenBrTrack: Label;
    labelRightParenOffAcptd: Label;
    labelRightParenPaprwork: Label;
    labelRightParenRateConf: Label;
    labelSubtracted: Label;
    labelWeightBrTrack: Label;
    labelWeightOffAcptd: Label;
    labelWeightPaprwork: Label;
    labelWeightRateConf: Label;
    panelBrTrackScoreDetails: Panel;
    panelFormulaBrTrack: Panel;
    panelFormulaOffAcptd: Panel;
    panelFormulaPaprwork: Panel;
    panelFormulaRateConf: Panel;
    panelOffAcptdScoreDetails: Panel;
    panelPaprworkScoreDetails: Panel;
    panelRateConfScoreDetails: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxEndOfPeriod: Textbox;
    textboxMinimumRecords: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
